var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container d-flex justify-content-center text-center" },
    [
      _c("h2", { staticClass: "text-white" }, [
        _vm._v("\n        " + _vm._s(_vm.$t("message.forbidden")) + "\n    "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }